import React from 'react'

const ResultsInfo = () => {
  return (
    <div className="content-wrapper">
      <h1>Bookmarked results</h1>

      <p>
        This page displays all your bookmarked results from our calculators.
      </p>
      <p></p>
      <p>
        To bookmark your information, click the &apos;save&apos; button while in
        the calculator. You&apos;ll receive a reference number and the option to
        bookmark to your account by clicking on &apos;My account&apos;.
      </p>
    </div>
  )
}

export default ResultsInfo
